export enum PolicyMode {
  PERMISSIVE = "permissive",
  WARN = "warn",
  STRICT = "strict"
}

export enum ValidationSeverity {
  ERROR = "error",
  WARNING = "warning",
  INFO = "info"
}

export enum HttpNoBodyStatus {
  NO_CONTENT_204 = 204,
  NOT_MODIFIED_304 = 304
}

export enum ValidationCode {
  ACTIONS_EMPTY = "ACTIONS_EMPTY",
  ACTION_NAME_MISSING = "ACTION_NAME_MISSING",
  ACTION_NAME_DUP = "ACTION_NAME_DUP",
  ACTION_DESC_MISSING = "ACTION_DESC_MISSING",
  ACTION_DESC_DUP = "ACTION_DESC_DUP",
  REQ_MISSING = "REQ_MISSING",
  RES_MISSING = "RES_MISSING",
  STATUS_MISSING = "STATUS_MISSING",
  STATUS_INVALID = "STATUS_INVALID",
  STATUS_FORBIDS_BODY = "STATUS_FORBIDS_BODY",
  REPS_EMPTY = "REPS_EMPTY",
  REP_NAME_MISSING = "REP_NAME_MISSING",
  REP_NAME_DUP = "REP_NAME_DUP",
  REP_BODYFILE_KEY_MISSING = "REP_BODYFILE_KEY_MISSING",
  REP_BODYFILE_TYPE = "REP_BODYFILE_TYPE",
  REP_CONTENTTYPE_KEY_MISSING = "REP_CONTENTTYPE_KEY_MISSING",
  REP_CONTENTTYPE_FORMAT = "REP_CONTENTTYPE_FORMAT",
  REP_DEFAULT_COUNT = "REP_DEFAULT_COUNT",
  REP_CT_NOT_IN_SCHEMA = "REP_CT_NOT_IN_SCHEMA",
  RES_BODYFILE_KEY_MISSING = "RES_BODYFILE_KEY_MISSING",
  RES_BODYFILE_TYPE = "RES_BODYFILE_TYPE",
  RES_BODYFILE_EMPTY = "RES_BODYFILE_EMPTY",
  POLICY_INVALID = "POLICY_INVALID",
  MATCH_UNKNOWN_RESPONSE = "MATCH_UNKNOWN_RESPONSE",
  MATCH_FORBIDDEN_HEADER = "MATCH_FORBIDDEN_HEADER",
  MATCH_HEADER_NOT_DECLARED = "MATCH_HEADER_NOT_DECLARED",
  BODYFILE_MISSING = "BODYFILE_MISSING",
  PARAM_NOT_IN_PATH = "PARAM_NOT_IN_PATH",
  PARSE_ERROR = "PARSE_ERROR",
  HEADERS_INVALID = "HEADERS_INVALID",
  HEADER_NOT_OBJECT = "HEADER_NOT_OBJECT",
  HEADER_NAME_INVALID = "HEADER_NAME_INVALID",
  HEADER_VALUE_INVALID = "HEADER_VALUE_INVALID",
  RESPONSES_EMPTY = "RESPONSES_EMPTY",
  RESPONSE_NOT_OBJECT = "RESPONSE_NOT_OBJECT",
  METHOD_MISSING = "METHOD_MISSING",
  METHOD_INVALID = "METHOD_INVALID"
}

export enum AuthScheme {
  BEARER = "Bearer"
}

export enum BodyMode {
  WARN = "warn",
  STRICT = "strict"
}

export enum DiagnosticsOnWarn {
  COLLECT = "collect",
  LOG = "log",
  THROW = "throw"
}

export enum HttpMethod {
  GET = "get",
  POST = "post",
  PUT = "put",
  PATCH = "patch",
  DELETE = "delete",
  HEAD = "head",
  OPTIONS = "options"
}
